import PreCSS from "../../src/utils/preRenderCSS";
import { useEffect, useState } from "react";
import Head from "next/head";
import Link from "../../src/components/Link";

import axios from "axios";

import { ptToVwConverter, mobileVwConverter } from "../../src/utils";
import useWindowSize from "../../src/utils/useWindowSize";

import { Button } from "@material-ui/core";

import {
  DecorationLine,
  TopContentsTitleContainer,
  TopContentsTitle,
  TopContentsContainer,
} from "../../src/components/style";
import {
  PerformancesContainer,
  PerformancesMain,
  CategoryWrapper,
  CategoryTitle,
  CategoryGrid,
  LinkButton,
  PerformancePhoto,
  CategoryItem,
  PerformancePhotoAlt,
  PerformanceTitle,
  PerformanceText,
} from "../../src/components/style/performances";

import { performanceCategories } from "../../src/config/Performances";

const buttons = [
  {
    id: "button-0",
  },
  {
    id: "button-1",
  },
  {
    id: "button-2",
  },
];

function Performances({
  performances,
  lang,
}: {
  performances: PerformanceObject[][];
  lang: string;
}) {
  const windowSize = useWindowSize();

  const isWindowClient = typeof window === "object";

  const [current, setCurrent] = useState(0);
  const [first, setFirst] = useState(0);
  const [second, setSecond] = useState(0);
  const [third, setThird] = useState(0);

  const [ready, setReady] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (!ready) {
      let id: NodeJS.Timeout;
      id = global.setInterval(() => {
        const mainPics = document.getElementsByClassName(
          "mainPic"
        ) as HTMLCollectionOf<HTMLImageElement>;
        let allReady = true;
        // tslint:disable-next-line: prefer-for-of
        for (let i = 0; i < mainPics.length; i++) {
          if (
            !mainPics[i].complete ||
            mainPics[i].naturalHeight === 0 ||
            mainPics[i].naturalWidth === 0
          ) {
            allReady = false;
          }
        }

        if (allReady) {
          const firstElement = document.getElementById(
            performanceCategories[0].id
          ) as HTMLElement;
          const secondElement = document.getElementById(
            performanceCategories[1].id
          ) as HTMLElement;
          const thirdElement = document.getElementById(
            performanceCategories[2].id
          ) as HTMLElement;

          setFirst(firstElement?.clientHeight);
          setSecond(secondElement?.clientHeight);
          setThird(thirdElement?.clientHeight);

          setTimeout(() => {
            setReady(true);
          }, 1000);

          if (id) {
            clearInterval(id);
          }
        }
      }, 100);
    }
  });

  useEffect(() => {
    const addCurrent = () => {
      setCurrent(window.pageYOffset);
    };

    const changeColor = () => {
      const firstButton = document.getElementById(buttons[0].id) as HTMLElement;
      const secondButton = document.getElementById(
        buttons[1].id
      ) as HTMLElement;
      const thirdButton = document.getElementById(buttons[2].id) as HTMLElement;

      if (!firstButton || !secondButton || !thirdButton) return;

      if (typeof current === "number" && done) {
        // console.log("Current: ", current);
        // console.log("1: ", first);
        // console.log("2: ", first + second);
        // console.log("3: ", first + second + third);
        if (current + 10 < first) {
          firstButton.style.backgroundColor = "#f2f2f2";
          secondButton.style.backgroundColor = "#fff";
          thirdButton.style.backgroundColor = "#fff";
        } else if (first <= current + 10 && current + 10 < first + second) {
          firstButton.style.backgroundColor = "#fff";
          secondButton.style.backgroundColor = "#f2f2f2";
          thirdButton.style.backgroundColor = "#fff";
        } else {
          firstButton.style.backgroundColor = "#fff";
          secondButton.style.backgroundColor = "#fff";
          thirdButton.style.backgroundColor = "#f2f2f2";
        }
      }
    };

    if (isWindowClient) {
      const firstElement = document.getElementById(
        performanceCategories[0].id
      ) as HTMLElement;
      const secondElement = document.getElementById(
        performanceCategories[1].id
      ) as HTMLElement;
      const thirdElement = document.getElementById(
        performanceCategories[2].id
      ) as HTMLElement;

      if (!first) {
        setFirst(firstElement?.clientHeight);
      }
      if (!second) {
        setSecond(secondElement?.clientHeight);
      }
      if (!third) {
        setThird(thirdElement?.clientHeight);
      }

      const resize = () => {
        addCurrent();
        setFirst(firstElement?.clientHeight);
        setSecond(secondElement?.clientHeight);
        setThird(thirdElement?.clientHeight);
      };

      window.addEventListener("scroll", resize, { passive: true });
      window.addEventListener("resize", resize, { passive: true });
      return () => {
        window.removeEventListener("scroll", resize);
        window.removeEventListener("resize", resize);
        changeColor();
      };
    }
  }, [isWindowClient, current]);

  useEffect(() => {
    if (!done) {
      const query =
        isWindowClient && window.location.search.slice(0, 3) === "?q="
          ? window.location.search.slice(3)
          : "";

      if (!query) {
        setDone(true);
      }

      if (query && first && second && ready) {
        const firstButton = document.getElementById(
          buttons[0].id
        ) as HTMLElement;
        const secondButton = document.getElementById(
          buttons[1].id
        ) as HTMLElement;
        const thirdButton = document.getElementById(
          buttons[2].id
        ) as HTMLElement;

        if (query === "performances") {
          window.scrollTo({
            top: 0,
          });

          if (firstButton && secondButton && thirdButton) {
            firstButton.style.backgroundColor = "#f2f2f2";
            secondButton.style.backgroundColor = "#fff";
            thirdButton.style.backgroundColor = "#fff";
          }

          setDone(true);
        } else if (query === "videoWorks") {
          const extra = windowSize === "mobile" ? 100 : 0;

          window.scrollTo({
            top: first + extra,
          });

          if (firstButton && secondButton && thirdButton) {
            firstButton.style.backgroundColor = "#fff";
            secondButton.style.backgroundColor = "#f2f2f2";
            thirdButton.style.backgroundColor = "#fff";
          }

          setDone(true);
        } else if (query === "outreach") {
          const extra = windowSize === "mobile" ? 100 : 0;

          window.scrollTo({
            top: first + second + extra,
          });

          if (firstButton && secondButton && thirdButton) {
            firstButton.style.backgroundColor = "#fff";
            secondButton.style.backgroundColor = "#fff";
            thirdButton.style.backgroundColor = "#f2f2f2";
          }

          setDone(true);
        }
      }
    }
  }, [ready]);

  return (
    <div>
      <PreCSS />
      <Head>
        <title>zerO パフォーマンス</title>
        <meta property="og:title" content="zerO パフォーマンス" />
        <meta
          property="og:description"
          content="zerO パフォーマンス一覧ページ"
        />
        <meta property="og:image" content="/assets/logoShare.jpg" />
        <meta
          property="og:url"
          content="https://zero-dance.com/performances/"
        />
        <meta name="twitter:card" content="summary_large_image" />
      </Head>

      <PerformancesContainer>
        <TopContentsContainer>
          {windowSize === "desktop" ? (
            <div style={{ position: "fixed", display: "flex" }}>
              <TopContentsTitleContainer>
                <TopContentsTitle>performances</TopContentsTitle>
              </TopContentsTitleContainer>
              <DecorationLine />
            </div>
          ) : windowSize === "mobile" || windowSize === "tablet" ? (
            <>
              <div
                style={{
                  fontSize: "18px",
                  letterSpacing: "0.1em",
                  textTransform: "uppercase",
                  fontWeight: 400,
                }}
              >
                performances
              </div>
              <DecorationLine />
            </>
          ) : (
            <p></p>
          )}

          <PerformancesMain>
            {performanceCategories.map((category, index) => (
              <CategoryWrapper id={category.id}>
                <CategoryTitle>
                  <div>
                    {lang === "ja"
                      ? category.title.ja
                      : lang === "en"
                      ? category.title.en
                      : ""}
                  </div>
                </CategoryTitle>
                <CategoryGrid container>
                  {lang ? (
                    performances[index].length ? (
                      performances[index].map((item, i) => {
                        const as = `/performances/${item.id}`;

                        const categoryContents = () => (
                          <LinkButton>
                            <Link href="/performances/[id]" as={as}>
                              {item.imgMain ? (
                                <PerformancePhoto
                                  src={item.imgMain?.url}
                                  alt={item.title}
                                  onContextMenu={(e) => {
                                    e.preventDefault();
                                    return false;
                                  }}
                                  className="mainPic"
                                />
                              ) : (
                                <PerformancePhotoAlt />
                              )}
                              <div
                                style={{
                                  width: "100%",
                                }}
                              >
                                <PerformanceTitle>
                                  {lang === "ja"
                                    ? item.title
                                    : lang === "en"
                                    ? item.titleEng
                                    : ""}
                                </PerformanceTitle>
                                <PerformanceText>
                                  {lang === "ja"
                                    ? item.location
                                    : item.locationEng}
                                </PerformanceText>
                              </div>
                            </Link>
                          </LinkButton>
                        );

                        return windowSize === "desktop" ? (
                          <CategoryItem item key={i} xs={4}>
                            {categoryContents()}
                          </CategoryItem>
                        ) : windowSize === "mobile" ||
                          windowSize === "tablet" ? (
                          <CategoryItem
                            item
                            key={i}
                            xs={6}
                            style={{
                              padding:
                                i % 2 === 0
                                  ? `0 ${mobileVwConverter(20)}vw 0 0`
                                  : `0 0 0 ${mobileVwConverter(20)}vw`,
                            }}
                          >
                            {categoryContents()}
                          </CategoryItem>
                        ) : (
                          <p></p>
                        );
                      })
                    ) : (
                      <div>
                        {lang === "ja"
                          ? "表示する情報がありません。"
                          : "No item found."}
                      </div>
                    )
                  ) : (
                    <></>
                  )}
                </CategoryGrid>
              </CategoryWrapper>
            ))}
          </PerformancesMain>
          {windowSize === "desktop" && (
            <div
              style={{
                width: `${ptToVwConverter(250)}vw`,
                position: "fixed",
                right: `${ptToVwConverter(200)}vw`,
              }}
            >
              <div
                style={{
                  fontSize: "20px",
                  letterSpacing: "0.2rem",
                  height: "35px",
                  marginBottom: `20px`,
                }}
              >
                CATEGORY
              </div>
              {buttons.map((button, i) => {
                let top: number;
                if (i === 0) {
                  top = 0;
                } else if (i === 1) {
                  top = first;
                } else if (i === 2) {
                  top = first + second;
                }

                return (
                  <Button
                    style={{
                      borderBottom: "solid 1px #d9d9d9",
                      width: "250px",
                      height: `50px`,
                      borderRadius: 0,
                      backgroundColor: i === 0 ? "#f2f2f2" : "#fff",
                      fontSize: "14px",
                    }}
                    onClick={() => {
                      window.scrollTo({
                        top,
                        behavior: "smooth",
                      });
                    }}
                    id={button.id}
                    aria-label={button.id}
                  >
                    <div style={{ width: "100%", display: "flex" }}>
                      <div
                        style={{
                          alignItems: "flex-start",
                          width: "fit-content",
                          letterSpacing: "0.1rem",
                          textTransform: "none",
                        }}
                      >
                        {lang === "ja"
                          ? performanceCategories[i].title.ja
                          : lang === "en"
                          ? performanceCategories[i].title.en
                          : ""}
                      </div>
                    </div>
                  </Button>
                );
              })}
            </div>
          )}
        </TopContentsContainer>
      </PerformancesContainer>
    </div>
  );
}

export async function getStaticProps() {
  const baseURL = process.env.MICRO_URL;

  const performancesURL =
    baseURL +
    "performance?limit=1000&fields=id,title,titleEng,location,locationEng,sponsor,sponsorEng,category,imgMain,eventDate";

  const config = {
    headers: {
      "X-API-KEY": process.env.MICRO_API_KEY,
    },
  };

  const res: PerformanceResponse = await axios.get(performancesURL, config);

  const rawPerformances = res.data.contents.sort((a, b) => {
    const aDate = a.publishedAt || "";
    const bDate = b.publishedAt || "";
    const recent = new Date(aDate).getTime();
    const old = new Date(bDate).getTime();
    return old - recent;
  });

  // FIXME: type
  const performances: any = [[], [], []];

  rawPerformances.forEach((raw) => {
    if (raw.category === performanceCategories[0].title.ja) {
      performances[0].push(raw);
    } else if (raw.category === performanceCategories[1].title.ja) {
      performances[1].push(raw);
    } else if (raw.category === performanceCategories[2].title.ja) {
      performances[2].push(raw);
    }
  });

  return {
    props: {
      performances,
      namespacesRequired: [],
    },
  };
}

export default Performances;
